import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button, ButtonIcon} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';

import { Link } from 'react-router-dom'

import * as api from '../../api/api';
import TPOPdfUpload from './TPOPdfUpload';




class TPOUploadAdmin extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',      
      data:{
        tpoUploadDetails: []
      },

    };

    
  }

  componentDidMount() {
   let data = Object.assign({}, this.state.data)
    return api.fetchAdminTPOUploadList(this.props.user.accessToken)
      .then((result) => {
        data.tpoUploadDetails = result.data
        this.setState({data: data})
    }).catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching TPO Admin Details. Please contact Admin' })
    })
  }

  render() {

   let componentsToShow
   let i=0
   let questionPdf = 'question-pdf' 
   if(this.state.data.tpoUploadDetails.length>0){
      componentsToShow=<GridCell span="12">
        {this.state.data.tpoUploadDetails.map(function(upload) {
          i++
          console.log(upload)
          if(upload.fileSubType.includes(questionPdf)){
            return(<TPOPdfUpload name={upload.name}
              uploadStatus={upload.uploadStatus}
              tpoTestTrackId={upload.tpoTestTrackId} 
              uploadTypeId={upload.id} 
              certType='TPO' 
              artifactURL={upload.link}
              uploadedCertId={upload.certUploadId}
              count={i}/>)
          }
          
        })}
        </GridCell>
    }  


    return (
      <Grid>
        <GridCell span="12">
          <Card style={{padding: '25px'}}>
            <div>
              <Typography use="headline6">TPO Questions upload</Typography>
              
            </div>
            <br/>
            {componentsToShow}
          </Card>
        </GridCell>
      </Grid>  
    )
  }


}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOUploadAdmin);



// WEBPACK FOOTER //
// ./src/views/admin/TPOUploadAdmin.jsx